<template>
  <ul class="sidebar-nav-menu-list">
    <li v-for="(item, index) in groups" :key="index">
      <a
        :class="{
          'menu-list-children': item.children.length > 0,
          active: isActiveItem(item.route),
        }"
        @click="item.children.length > 0 ? toggleChild(index) : clickItem(item)"
      >
        <span> {{ item.label }}</span>
        <v-icon v-if="item.children.length > 0" class="chevron-icon">
          mdi-chevron-down
        </v-icon>
      </a>
      <recursive-list
        v-if="item.children.length > 0"
        :groups="item.children"
        v-show="item.expanded"
      />
    </li>
  </ul>
</template>
<script>
export default {
  name: 'RecursiveList',
  components: {
    RecursiveList: this,
  },
  props: {
    groups: {
      type: Array,
    },
  },
  data() {
    return {}
  },
  methods: {
    toggleChild(index) {
      this.$set(this.groups[index], 'expanded', !this.groups[index].expanded)
    },
    clickItem(item) {
      this.$router.push(item.route)
    },
    isActiveItem(route) {
      return this.$route.path === route
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .theme--light.v-icon:focus::after {
  opacity: 0 !important;
}
::v-deep .c-custom-list .router-link-active {
  font-weight: bold;
}
</style>

<style>
.active {
  font-weight: bold;
}
</style>
<style scoped lang="scss" src="./styles.scss" />
